<template>
  <div class="detail-pembayaran">
    <!-- Tanpa BPJS -->
    <b-row align-v="center" class="mb-4 mt-50">
      <b-col cols="11">
        <b-row align-v="center">
          <b-col cols="3" align="center"><b>OBAT/BAHAN HABIS PAKAI</b></b-col>
          <b-col cols="2" align="center"><b>HARGA</b></b-col>
          <b-col cols="1" class="px-1" align="center"><b>QTY</b></b-col>
          <b-col cols="2" align="center"><b>DISKON</b></b-col>
          <b-col cols="2" align="center"><b>NILAI DISKON</b></b-col>
          <b-col cols="2" align="right"><b>SUBTOTAL</b></b-col>
        </b-row>
      </b-col>

      <b-col v-if="layananNormal.length < 1" cols="12" align="center" class="d-block pt-4">
        <font-awesome-layers class="fa-lg btn-actions btn-tambah" @click="tambah">
          <font-awesome-icon icon="circle" />
          <font-awesome-icon icon="plus" transform="shrink-6" class="text-white" />
        </font-awesome-layers>
      </b-col>
    </b-row>

    <b-row class="mb-4" v-for="(item, index) in layananNormal" :key="index" footer-tag="footer">
      <b-col cols="11" class="pr-0">
        <b-card>
          <b-card-text>
            <b-row align-v="center">
              <b-col cols="3">
                <b-media>
                  <template #aside>
                    <div class="text-center mt-2" @click="isClick(index)">
                      <font-awesome-icon icon="chevron-circle-up" v-if="item.is_click" class="icon-collapse" />
                      <font-awesome-icon icon="chevron-circle-down" v-else class="icon-collapse" />
                    </div>
                  </template>
                  <multiselect v-model="item.layanan" :options="listLayanan" :group-select="false" v-show="true"
                    @input="inputLayanan($event, index)" :show-labels="false"
                    :class="{ 'is-invalid': layananErrors.includes(item.nama_layanan) }" track-by="name" label="name"
                    :disabled="bayar || waitingQrisPayment">
                    <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                    <template slot="option" slot-scope="props">
                      <span v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
                      <span class="pl-3" v-else>{{ props.option.name }}</span>
                    </template>
                  </multiselect>
                  <div class="text-danger" :class="{ 'd-none': !layananErrors.includes(item.nama_layanan) }">
                    Pilihan tidak boleh sama
                  </div>
                  <div class="text-danger"
                    :class="[(!item.stok_available && item.stok_temp != null) ? 'd-block' : 'd-none']">
                    Sisa stok: {{ item.layanan.stok || 0 }}
                  </div>
                </b-media>
              </b-col>
              <b-col cols="2">
                <div class="d-flex align-items-center">
                  <money :value="item.tarif" v-bind="money" disabled
                    :class="bayar ? 'is-paid form-control flex-grow-1 text-right' : 'form-control flex-grow-1 text-right'" />
                </div>
              </b-col>
              <b-col cols="1" class="px-1">
                <b-form-input @input="checkStock($event, index)" min="0" @keypress="isNumber($event)" type="number"
                  v-model="item.quantity" :disabled="bayar || waitingQrisPayment"
                  :class="{ 'is-paid': bayar, 'mt-4': (item.quantity === null || item.quantity === '') && bayar }" />
                <div class="invalid-feedback d-block" v-if="(item.quantity === null || item.quantity === '') && bayar">
                  Kolom harus diisi
                </div>
              </b-col>
              <b-col cols="2">
                <multiselect v-model="selectedDiskon[index]" :options="optDiskon" placeholder="Diskon" label="name"
                  track-by="name" @input="selectedDiskonItem($event, index)" :show-labels="false" :disabled="bayar || waitingQrisPayment">
                </multiselect>
              </b-col>
              <b-col cols="2">
                <b-form-input v-if="item.jenis_potongan == 'PERSENTASE'" v-model="item.potongan" :readonly="item.readonly"
                  @keypress="isNumberPersentase($event, index)" @input="setInput($event, index)" :disabled="bayar || waitingQrisPayment"
                  :class="bayar ? 'is-paid form-control' : 'form-control'" />
                <money v-else v-model="item.potongan" v-bind="money2" :readonly="item.readonly"
                  @keypress.native="isNumberRupiah($event, index)" @input="setInput($event, index)" :disabled="bayar || waitingQrisPayment"
                  :class="bayar ? 'is-paid form-control' : 'form-control'" />
              </b-col>
              <b-col cols="2">
                <div class="d-flex align-items-center">
                  <money v-model="item.subtotal_tarif_net" v-bind="money" disabled
                    :class="bayar ? 'is-paid form-control flex-grow-1 text-right' : 'form-control flex-grow-1 text-right'" />
                </div>
              </b-col>
            </b-row>
            <b-row align-v="center" v-if="errorMessage.length > 0">
              <b-col cols="3">
                <div class="text-danger" style="margin-left: 42px"
                  v-if="checkErrorMessage(index, 'nama_layanan') && !checkErrorMessage(index, 'nama_layanan').status">
                  {{ checkErrorMessage(index, 'nama_layanan').message }}
                </div>
              </b-col>
              <b-col cols="2">

              </b-col>
              <b-col cols="1">
                <div class="text-danger"
                  v-if="checkErrorMessage(index, 'quantity') && !checkErrorMessage(index, 'quantity').status">
                  {{ checkErrorMessage(index, 'quantity').message }}
                </div>
              </b-col>
              <b-col cols="2">

              </b-col>
              <b-col cols="2">

              </b-col>
            </b-row>
          </b-card-text>
          <b-card-footer class="p-0">
            <div class="ml-5 py-3 set-comission" @click="isClick(index)" v-if="!item.is_click"><b>Atur Komisi</b></div>
            <div class="ml-5" v-else>
              <template v-if="item.is_comission">
                <b-row>
                  <b-col cols="6" :class="{ 'r-divinder': item.comission.length > 1 }">
                    <div class="py-3">
                      <p class="set-comission" @click="isClick(index)"><b>Atur Komisi</b></p>
                      <b-row>
                        <b-col cols="4"><b>Jenis User</b></b-col>
                        <b-col cols="8"><b>PIC</b></b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col cols="6" v-if="item.comission.length > 1">
                    <div class="py-3">
                      <p class="text-white">.</p>
                      <b-row>
                        <b-col cols="4"><b>Jenis User</b></b-col>
                        <b-col cols="8"><b>PIC</b></b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" :class="{ 'r-divinder': i % 2 !== 1 && item.comission.length > 1 }"
                    v-for="(v, i) in item.comission" :key="i">
                    <b-row class="pb-3">
                      <b-col cols="4">
                        <b-form-input type="text" disabled :value="v.display_name" />
                      </b-col>
                      <b-col cols="8" class="pr-5">
                        <multiselect v-model="item.selectedComission[v.name]" :options="v.users" label="name"
                          track-by="name" @input="selectedPIC($event, index, v.name)" :show-labels="false"
                          :disabled="false">
                        </multiselect>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <b-row>
                  <b-col cols="6" class="pt-3 set-comission" @click="isClick(index)">
                    <p><b>Atur Komisi</b></p>
                  </b-col>
                  <b-col cols="12" align="center">
                    <p>Anda belum membuat skema komisi untuk Tindakan/Obat/Bahan Habis Pakai ini, silakan membuat skema
                      komisi di menu Manajemen Komisi.</p>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col cols="1" class="pl-0 mt-4" v-if="!bayar">
        <div class="d-flex flex-shrink-1 justify-content-around ml-2 action-pembayaran">
          <font-awesome-layers class="fa-lg ml-2 btn-actions action-pembayaran-kurang" 
            :style="{color: waitingQrisPayment ? '#cdcdcd' : 'red'}" @click="kurang(index)">
            <font-awesome-icon icon="circle" />
            <font-awesome-icon icon="minus" transform="shrink-6" class="text-white" />
          </font-awesome-layers>
          <font-awesome-layers class="fa-lg ml-2 btn-actions btn-tambah d-none d-lg-inline" 
            :style="{color: waitingQrisPayment ? '#cdcdcd' : '#0d74df'}" @click="tambah('up')">
            <template v-if="(index + 1) === layananNormal.length">
              <font-awesome-icon icon="circle" />
              <font-awesome-icon icon="plus" transform="shrink-6" class="text-white" />
            </template>
            <template v-else>&nbsp;</template>
          </font-awesome-layers>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faPlus, faMinus, faCircle, faChevronCircleDown, faChevronCircleUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome"
import { mapGetters } from "vuex"
import { Money } from 'v-money'
import Multiselect from 'vue-multiselect'
library.add(faPlus, faMinus, faCircle, faChevronCircleDown, faChevronCircleUp)

export default {
  components: {
    FontAwesomeLayers,
    Multiselect,
    Money
  },
  props: ['items', 'poli', 'bayar', 'bpjs', 'errorMessage', 'waitingQrisPayment'],
  data: () => ({
    money: {
      decimal: "",
      thousands: ",",
      prefix: "Rp. ",
      suffix: "",
      precision: 0,
      masked: false
    },
    money2: {
      decimal: "",
      thousands: ",",
      prefix: "",
      suffix: "",
      precision: 0,
      masked: false
    },
    details: [],
    layananNormal: [],
    listLayanan: [],
    layananErrors: [],
    selectedDiskon: [],
    optDiskon: [
      { value: 'PERSENTASE', name: '%' },
      { value: 'RUPIAH', name: 'Rupiah' }
    ],
    // bpjs
    obatBpjs: [],
    tindakanBpjs: []
  }),
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  async mounted() {
    // this.details = await this.items

    // console.log(this.details.length > 0);
    // if (this.details.length > 0) {
    //   this.details.forEach((item, index) => {
    //     if (item.jenis_potongan == 'PERSENTASE') this.selectedDiskon[index] = { value: 'PERSENTASE', name: '%' }
    //     else if (item.jenis_potongan == 'RUPIAH') this.selectedDiskon[index] = { value: 'RUPIAH', name: 'Rupiah' }


    //     // this.details[index].layanan = {
    //     //   value: item.id,
    //     //   name: `${item.nama_layanan.length >= 45 ? item.nama_layanan.substring(0, 45) + ' ...' : item.nama_layanan} - ${item.kode_layanan}`,
    //     //   stok: item.stok,
    //     // }

    //     this.fetchComissionLayanan(item.layanan_id, index)

    //   })
    // }

    this.fetchLayanan()
    this.calcValue(this.details)
    this.getLayananType();
    this.setLayananType();
    this.determineDuplicateLayanan()
  },
  watch: {
    items: {
      immediate: true,
      handler(newVal, oldVal) {
        // Check if the prop has changed (optional)

        if (newVal !== oldVal) {
          this.details = newVal

          newVal.forEach((item, index) => {
            if (item.jenis_potongan == 'PERSENTASE') this.selectedDiskon[index] = { value: 'PERSENTASE', name: '%' }
            else if (item.jenis_potongan == 'RUPIAH') this.selectedDiskon[index] = { value: 'RUPIAH', name: 'Rupiah' }

            this.details[index].layanan = {
              value: item.id,
              name: `${item.nama_layanan.length >= 45 ? item.nama_layanan.substring(0, 45) + ' ...' : item.nama_layanan} - ${item.kode_layanan}`,
              stok: item.stok,
            }

            this.fetchComissionLayanan(item.layanan_id, index)

          })
        }

      },
    },
    details: {
      deep: true,
      handler: function (newVal) {
        newVal.forEach(detail => {
          if (detail.potongan != null && detail.potongan != "") {
            if (detail.jenis_potongan == 'PERSENTASE' || detail.jenis_potongan == 'percentase') {
              let nd = parseFloat((detail.potongan + '').replace(',', '.'))
              detail.subtotal_tarif = parseInt(detail.quantity) * parseInt(detail.tarif)
              detail.subtotal_tarif_net = parseInt(detail.quantity) * parseInt(detail.tarif) * (100 - nd) / 100
            } else if (detail.jenis_potongan == 'RUPIAH' || detail.jenis_potongan == 'rupiah') {
              detail.subtotal_tarif = parseInt(detail.quantity) * parseInt(detail.tarif)
              detail.subtotal_tarif_net = parseInt(detail.quantity) * parseInt(detail.tarif) - parseFloat(detail.potongan)
            }
          } else {
            detail.subtotal_tarif = detail.quantity != '' ? parseInt(detail.quantity) * parseInt(detail.tarif) : 0 * parseInt(detail.tarif)
            detail.subtotal_tarif_net = detail.quantity != '' ? parseInt(detail.quantity) * parseInt(detail.tarif) : 0 * parseInt(detail.tarif)
          }

          if (detail.jenis_potongan != null) detail.readonly = false
        })
        this.getLayananType();
        this.setLayananType();
        this.calcValue(newVal)
      }
    },
    layananErrors(newVal) {
      this.$emit('layananDuplicateErrorState', newVal.length > 0)
    },
  },
  methods: {
    getLayananType() {
      this.layananNormal = []
      this.obatBpjs = []
      this.tindakanBpjs = []

      this.details.forEach((item) => {
        if (item.from_bpjs == 0 || item.from_bpjs == '') {
          this.layananNormal.push(item);
        } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 0) {
          this.tindakanBpjs.push(item);
        } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 1) {
          this.obatBpjs.push(item);
        }
      })
    },
    setLayananType() {
      this.$emit('groupLayananType', {
        tindakanBpjs: this.tindakanBpjs,
        obatBpjs: this.obatBpjs,
        mandiri: this.layananNormal
      });
    },
    checkErrorMessage(i, key) {
      return this.errorMessage.filter(item => item.index == i && item.key == key)[0];
    },
    isNumberPersentase: function (evt, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      let theEvent = evt || window.event
      let key = theEvent.keyCode || theEvent.which
      key = String.fromCharCode(key)
      if (key.length == 0) return
      let regex = /^[0-9,\b]+$/
      if (!regex.test(key)) {
        theEvent.returnValue = false
        if (theEvent.preventDefault) theEvent.preventDefault()
      }

      let regex2 = /^[0-9]*(,[0-9]{0,2})?$/
      if (
        regex2.test(this.details[index].potongan + evt.key) == false
        || parseInt(this.details[index].potongan + evt.key) > 100
        || parseInt(this.details[index].potongan + evt.key) < 0
      ) {
        evt.preventDefault()
      }
      return true
    },
    isNumberRupiah: function (evt, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      let theEvent = evt || window.event
      let key = theEvent.keyCode || theEvent.which
      key = String.fromCharCode(key)
      if (key.length == 0) return
      let regex = /^[0-9\b]+$/
      if (!regex.test(key)) {
        theEvent.returnValue = false
        if (theEvent.preventDefault) theEvent.preventDefault()
      }

      if (
        parseInt(this.details[index].potongan + evt.key) > this.details[index].subtotal_tarif
        || parseInt(this.details[index].potongan + evt.key) < 0
      ) {
        evt.preventDefault()
      }
      return true
    },
    selectedDiskonItem($event, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      if ($event == null) {
        this.details[index].jenis_potongan = null
        this.details[index].potongan = 0
        this.details[index].readonly = true
      } else {
        this.details[index].jenis_potongan = $event.value
        this.details[index].potongan = 0
        this.details[index].readonly = false
      }
    },
    setInput($event, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      let evt = $event
      if (evt == null || evt == "") {
        this.details[index].potongan = 0
      } else {
        this.details[index].potongan = evt
      }
    },
    calcValue(val) {
      this.$emit("valueChanged", val);
    },
    calculateSubtotal(item) {
      return item.quantity * 12345
    },
    toNumber(v) {
      return parseInt(v.replace(/\D/g, ""))
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 47 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    tambah(type = 'up') {
      this.$emit("isBayarStatus", false)
      const { details, layananNormal } = this
      if (layananNormal.length > 0) {
        const tmp = details[details.length - 1]
        this.details = [
          ...details,
          Object.keys(tmp).reduce((obj, val) => {
            if (val === "no") {
              obj[val] = parseInt(tmp[val]) + 1
            } else if (val === "quantity") {
              obj[val] = 1
            } else {
              obj[val] = ""
            }
            obj['pembayaran_id'] = this.$router.currentRoute.params.bayar_id
            obj['is_click'] = false
            obj['is_comission'] = false
            obj['selectedComission'] = {}
            obj['comission'] = {}
            obj['komisi_id'] = null
            obj['komisi'] = []
            obj['stok'] = null
            obj['stok_available'] = true
            obj['stok_temp'] = '0'
            obj['from_bpjs'] = 0,
              obj['bpjs_sk_type'] = null
            obj['tarif'] = 0
            obj['subtotal_tarif'] = 0,
              obj['subtotal_tarif_net'] = 0
            return obj
          }, {})
        ]
      } else {
        this.details.push({
          no: 1,
          id: null,
          pembayaran_id: this.$router.currentRoute.params.bayar_id,
          layanan_id: null,
          kode_layanan: null,
          nama_layanan: null,
          quantity: 1,
          tarif: 0,
          potongan: 0,
          jenis_potongan: null,
          subtotal_tarif: 0,
          subtotal_tarif_net: 0,
          readonly: true,
          is_click: false,
          is_comission: false,
          selectedComission: {},
          comission: {},
          komisi_id: null,
          satuan_id: null,
          keterangan: null,
          komisi: [],
          stok: null,
          from_bpjs: 0,
          bpjs_sk_type: null,
          layanan: {
            stok: null
          },
          stok_available: true,
        })
      }

      if (type == 'up')
        this.$emit("validationInputEvt", details)
    },
    kurang(i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      this.$emit("isBayarStatus", false)
      const { details } = this
      const tmp = details.splice(index, 1)
      if (details.length > 0) {
        this.details = [
          ...this.details.map((item, index) => {
            return {
              ...item,
              no: index + 1
            }
          })
        ]
      }

      let newLayananErrors = []
      this.layananErrors.forEach(item => {
        if (tmp[0].kode_layanan != item) newLayananErrors.push(item)
      })
      this.layananErrors = newLayananErrors
      this.determineDuplicateLayanan()
      this.$emit("validationInputEvt", details)
    },
    async fetchLayanan() {
      try {
        const res = await this.$axios.get(
          `penjualan/list-item?klinik_id=${this.getKlinikId}`
        )
        const { data, status } = res.data

        if (status) {

          for (let i = 0; i < data.length; i++) {

            const obat = {
              name: data[i].nama_layanan,
              value: data[i].id,
              kode_layanan: data[i].kode_layanan.split(' - ')[0] || '-',
              nama_layanan: data[i].nama_layanan.split(' - ')[0] || '-',
              tarif: data[i].tarif,
              stok: data[i].stok
            }
            this.listLayanan.push(obat)
          }

        }
      } catch (err) { }
    },
    isClick(i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      this.details[index].is_click = !this.details[index].is_click
    },
    checkStock($event, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      if (this.details[index].stok != null && !isNaN(parseInt($event))) {
        this.details[index].stok_available = parseInt(this.details[index].stok) >= parseInt($event)
      }
      this.$emit("validationInputEvt", this.details);
    },
    inputLayanan($event, i) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      this.details[index].jenis_potongan = null
      this.details[index].potongan = 0
      this.details[index].readonly = true
      if ($event == null) {
        this.details[index].nama_layanan = ""
        this.details[index].kode_layanan = 0
        this.details[index].layanan = ""
        this.details[index].tarif = 0
      } else {
        this.details[index].nama_layanan = $event.nama_layanan
        this.details[index].kode_layanan = $event.kode_layanan
        this.details[index].layanan_id = $event.value
        this.details[index].tarif = $event.tarif
        if ($event.stok != null && !isNaN(parseInt(this.details[index].quantity))) {
          this.details[index].stok = parseInt($event.stok)
          this.details[index].stok_available = parseInt($event.stok) >= parseInt(this.details[index].quantity)
          this.details[index].stok_temp = $event.stok ? '1' : '0'
        }else{
          this.details[index].stok_available = true
          this.details[index].stok_temp = '0'
          this.details[index].stok = null
        }
        this.fetchComissionLayanan($event.value, index)
      }

      this.determineDuplicateLayanan()
      this.$emit("validationInputEvt", this.details);
    },
    determineDuplicateLayanan() {
      let duplicate = []
      this.details.forEach((det, detIndex) => {
        let found = false
        this.details.forEach((detail, detailIndex) => {
          if (detIndex != detailIndex) {
            if (det.nama_layanan == detail.nama_layanan && (det.nama_layanan != null && det.nama_layanan != '')) {
              found = true
            }
          }
        })

        if (found && !duplicate.includes(det.nama_layanan)) {
          duplicate.push(det.nama_layanan)
        }
      })
      this.layananErrors = duplicate
    },
    async fetchComissionLayanan(layanan_id, index) {
      try {
        const res = await this.$axios.get(
          `klinik/get-pic-layanan?klinik_id=${this.getKlinikId}&layanan_id=${layanan_id}`
        )
        const { data, status } = res.data

        if (status && data.length > 0) {
          this.details[index].is_click = true
          this.details[index].is_comission = true
          this.details[index].comission = data
          this.details[index].komisi_id = data[0].komisi_id
          this.details[index].komisi = data.map((v) => ({
            role_id: v.role_id,
            display_name: v.display_name,
            role_name: v.name,
            user_id: null,
          }))

          if (this.details[index].selectedComission) {
            for (let key in this.details[index].selectedComission) {
              this.details[index].komisi = this.details[index].komisi.map(v => {
                if (key === v.role_name) {
                  return {
                    ...v,
                    user_id: this.details[index].selectedComission[key].id || null
                  }
                }
                return v
              })
            }
          }
          this.calcValue(this.details)
          this.getLayananType();
          this.setLayananType();
        } else {
          this.details[index].is_click = false
          this.details[index].is_comission = false
          this.details[index].comission = {}
          this.details[index].komisi_id = null
          this.details[index].komisi = []
        }
      } catch (err) { }
    },
    selectedPIC($event, i, key) {
      // get index after separate tindakan type
      const index = i + this.obatBpjs.length + this.tindakanBpjs.length
      this.details[index].selectedComission[key] = $event
      this.details[index].komisi = this.details[index].komisi.map(v => {
        if (v.role_name === key) {
          return { ...v, user_id: $event.id }
        }
        return v
      })
      this.calcValue(this.details)
      this.getLayananType();
      this.setLayananType();
    },

  }
};
</script>

<style lang="scss" scoped>
.detail-pembayaran {
  zoom: 90%;
}

.btn-actions {
  font-size: 26px;
  cursor: pointer;
}

.btn-tambah {
  color: #409eff;
}

.action-pembayaran-kurang {
  color: red;
}

@media screen and (max-width: 992px) {
  .action-pembayaran {
    margin-right: -45px !important;
  }

  .action-pembayaran-kurang {
    border-radius: 100%;
    -webkit-box-shadow: 4px 0px 8px 0px rgba(204, 204, 204, 1);
    -moz-box-shadow: 4px 0px 8px 0px rgba(204, 204, 204, 1);
    box-shadow: 4px 0px 8px 0px rgba(204, 204, 204, 1);
  }
}

.icon-collapse {
  font-size: 25px;
  color: #46aa6e;
  cursor: pointer;
}

.card {
  border: 1px solid rgba(122, 123, 151, 0.3);
}

.card-body {
  padding: 0;
}

.card-text {
  padding: 1rem;
  margin: 0;
}

.r-divinder {
  border-right: 1px solid rgba(122, 123, 151, 0.3);
}

input[disabled="disabled"] {
  background-color: transparent;
}

input[readonly="readonly"] {
  background-color: transparent;
}

.set-comission {
  cursor: pointer;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mt-100 {
  margin-top: 100px;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.table {
  &.table-pembayaran {
    thead {
      th {
        background-color: transparent !important;
      }
    }
  }
}

.card-payment {
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(122, 123, 151, 0.3);
  border-radius: 0.65rem;
  box-shadow: 0 0.46875rem 2.1875rem rgb(0 0 0 / 3%), 0 0.9375rem 1.40625rem rgb(0 0 0 / 3%), 0 0.25rem 0.53125rem rgb(0 0 0 / 5%), 0 0.125rem 0.1875rem rgb(0 0 0 / 3%);
}

.multiselect--disabled {
  opacity: 1;
  background: #eeeff8 !important;
}

.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #eeeff8 !important;
}

.multiselect--disabled .multiselect__tags {
  background: #eeeff8 !important;
  border: 1px solid #d1d2db !important;
}

.multiselect--disabled .multiselect__single {
  background: #eeeff8 !important;
}

/* For Firefox */
/* input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
} */

/* Chrome, Safari, Edge, Opera */
/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
} */
</style>
